/* eslint-disable react-hooks/exhaustive-deps */
import RangeSettings from '../RangeSettings';
import useRangeSettings from '../RangeSettings/hooks/useRangeSettings';
import Slider from '../Slider';
import useGetValue from '../hooks/useGetValue';
import styles from './EditProperty.module.scss';
import { yupResolver } from '@hookform/resolvers/yup';
import cn from 'classnames';
import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

const schemas = {
  integerSchema: yup.number().integer().required(),
  floatSchema: yup.number().required(),
  stringSchema: yup.string().min(1).required(),
};

const Input = ({ payload, submit, time }) => {
  const currentValue = useGetValue(payload.id);
  const [showSettings, setShowSettings] = useState(false);
  const [rangeSettings, setRangeSettings] = useRangeSettings(payload.id);

  const schema = useMemo(() => {
    return yup
      .object({
        field: schemas[`${payload.type || 'string'}Schema`],
      })
      .required();
  }, [payload.type]);

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
    watch,
    getValues,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      field: currentValue,
    },
    mode: 'all',
  });

  useEffect(() => {
    reset({
      field: currentValue,
    });
  }, [time]);

  const onSubmit = (data) => {
    submit(data);
  };

  const value = watch('field', currentValue);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={cn(styles.field, errors.field && styles.error)}>
          <input type="text" {...register('field')} autoComplete="off" />

          <div className={styles.actions}>
            <input className={styles.submit} type="submit" disabled={!isDirty || errors.field} />
            <span
              className={styles.settings}
              onClick={() => {
                setShowSettings((s) => !s);
              }}
            ></span>
          </div>
        </div>
      </form>

      <Slider
        rangeSettings={rangeSettings}
        value={value}
        setValue={setValue}
        type={payload.type}
        onConfirm={() => {
          submit({
            field: getValues('field'),
          });
        }}
      />

      {showSettings && <RangeSettings id={payload.id} rangeSettings={rangeSettings} setRangeSettings={setRangeSettings} />}
    </>
  );
};

export default Input;
